export default __webpack_public_path__ + "static/media/logo-cmtech.e6f2479a.png";